import Cookies from 'js-cookie'
import { getElement } from '../utils/functional'

export default class {
  constructor (el) {
    this.els = {
      el,
      button: getElement('.ck-Banner_Button', { context: el })
    }

    this.els.button.addEventListener('click', e => {
      Cookies.set('oxygenetix-cookie-banner', 'true', {
        expires: 3650
      })

      this.els.el.classList.remove('ck-Banner-active')
    })

    if (Cookies.get('oxygenetix-cookie-banner') === undefined) {
      this.els.el.classList.add('ck-Banner-active')
    }
  }
}
